export const SHOW_REPORT = 'SHOW_REPORT'
export const HIDE_REPORT = 'HIDE_REPORT'

export const showReport = () => ({type: SHOW_REPORT})
export const hideReport = () => ({type: HIDE_REPORT})
